export default "__VITE_ASSET__Bkuyg5fA__"